module.exports = __webpack_public_path__ + "img/centro2.1e8da2d1.jpg";